"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardStepByStep = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const steps_1 = tslib_1.__importDefault(require("antd/es/steps"));
const __1 = require("..");
exports.CardStepByStep = ({ className, number, label, subLabel }) => {
    return (React.createElement("div", { className: `clp-card-step-by-step ${className ? className : ''}` },
        number !== undefined && (React.createElement("div", { className: 'mr-20' },
            React.createElement(steps_1.default, { initial: number - 1, current: number - 1, direction: 'vertical' },
                React.createElement(__1.Step, null)))),
        React.createElement("div", null,
            React.createElement("div", { className: 'clp-card-step-by-step--sub-label' }, subLabel),
            React.createElement("div", { className: 'clp-card-step-by-step--label' }, label))));
};
//# sourceMappingURL=CardStepByStep.js.map